import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutMe from "./AboutMe/AboutMe";
import Stats from "./Stats/Stats";
import Home from "./Home/Home";
import Map from "./Map/Map";
import PLApp from "./PL/PLApp";
import Records from "./Records/Records";
import NotFound from "./NotFound";

class App extends Component {

    render() {
        return (
            <Router>
                <Routes>
                    <Route path="/me" element={<AboutMe />} />
                    <Route path="/me/" element={<AboutMe />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/stats/" element={<Stats />} />
                    <Route path="/map" element={<Map />} />
                    <Route path="/map/" element={<Map />} />
                    <Route path="/pl" element={<PLApp />} />
                    <Route path="/pl/" element={<PLApp />} />
                    <Route path="/pl/create-password" element={<PLApp />} />
                    <Route path="/pl/create-password/" element={<PLApp />} />
                    <Route path="/records" element={<Records />} />
                    <Route path="/records/" element={<Records />} />
                    <Route exact path="/" element={<Home />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        );
    }
}

export default App;
